import { Stack } from 'src/components-v2/Layout';
import { CmsMediaSwitch } from 'src/components-v2/Media';
import RichTextSwitch from 'src/containers/RichTextSwitch/RichTextSwitch';
import { useIsDarkBackground } from 'src/contexts';
import { useCmsTheme } from 'src/contexts/CmsThemeContext/CmsThemeContextProvider';
import { ctaBlockStyles } from './CtaBlockWithImage.styles';

// TODO: [redacted]#####################################
const CtaBlockWithImage = ({ node }) => {
  const fields = node?.data?.target?.fields;
  const isDarkBackground = useIsDarkBackground();
  const cmsTheme = useCmsTheme();

  return (
    <Stack
      className='cta-block'
      flexDirection='row'
      gap={3}
      sx={{
        padding: '2.0rem 0 0',
        ...ctaBlockStyles({ cmsTheme, isDarkBackground }),
        '& img': {
          maxWidth: { xs: 'none', sm: 'none', md: '100%' },
        },
        blockquote: {
          padding: '0',
          margin: '0',
        },
        ...fields?.styles,
      }}
    >
      {fields?.asset && (
        <CmsMediaSwitch
          asset={fields?.asset?.fields}
          width={fields?.asset?.fields?.width}
          height={fields?.assets?.fields?.height}
          queryString={{
            xs: '?fm=webp&w=108&q=60',
            sm: '?fm=webp&w=108&q=60',
            md: '?fm=webp&w=280&q=60',
            lg: '?fm=webp&w=280&q=60',
          }}
          sx={{
            width: {
              xs: '54px',
              md: fields?.asset?.fields?.width || '140px',
            },
          }}
          sys={fields?.asset?.sys}
        />
      )}
      <Stack alignItems='flex-start' justifyContent={'center'}>
        <RichTextSwitch
          sys={node?.data?.target?.sys}
          content={fields?.body}
          nodes={{
            p: {
              variant: 'p2',
              fieldId: 'body',
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default CtaBlockWithImage;
